import React from "react";
import { motion } from "framer-motion";

const Places = () => {
  const dreamPlaces = [
    // --- Destinasi Indonesia ---
    { name: "Air Terjun Sipiso-piso", location: "Karo, Sumatera Utara", note: "Air terjun 120m yang jatuh langsung ke arah Danau Toba. Ikonik! 🌊", poster: "/posters/sipisopiso.jpg" },
    { name: "Gunung Kerinci", location: "Jambi, Sumatera", note: "Gunung berapi tertinggi di Indonesia. Bisa lihat Samudra Hindia dari puncak. 🌋", poster: "/posters/kerinci.jpg" },
    { name: "Danau Ranau", location: "Lampung & OKU Selatan", note: "Danau terbesar kedua di Sumatera dengan latar Gunung Pesagi. 🏔️", poster: "/posters/ranau.jpg" },
    { name: "Gunung Prau", location: "Dieng, Jawa Tengah", note: "Pemandangan Golden Sunrise terbaik dan medan ramah pemula. ☀️", poster: "/posters/prau.jpg" },
    { name: "Gunung Merbabu", location: "Jawa Tengah", note: "Sabana rumput luas dengan deretan pemandangan gunung lainnya. 🌿", poster: "/posters/merbabu.jpg" },
    { name: "Gunung Bromo", location: "Jawa Timur", note: "Lautan pasir dan kawah aktif yang sangat populer saat sunrise. 🌋", poster: "/posters/bromo.jpg" },
    { name: "Air Terjun Madakaripura", location: "Probolinggo, Jawa Timur", note: "Air terjun tertinggi di Jawa, berbentuk melingkar di dalam tebing. 💧", poster: "/posters/madakaripura.jpg" },
    { name: "Air Terjun Banyumala", location: "Buleleng, Bali", note: "Air terjun kembar paling asri dengan kolam alami yang jernih. 🏊‍♀️", poster: "/posters/banyumala.jpg" },
    { name: "Pantai Kelingking", location: "Nusa Penida, Bali", note: "Tebing ikonik berbentuk siluet kepala T-Rex. Curam dan menantang! 🦖", poster: "/posters/kelingking.jpg" },
    { name: "Diamond Beach", location: "Nusa Penida, Bali", note: "Tangga tebing putih dan air laut biru toska yang kontras. 💎", poster: "/posters/diamond.jpg" },
    { name: "Air Terjun Benang Kelambu", location: "Lombok Tengah, NTB", note: "Air yang keluar dari celah tanaman, terlihat seperti tirai tipis. 🧶", poster: "/posters/kelambu.jpg" },
    { name: "Pantai Nihiwatu", location: "Sumba Barat, NTT", note: "Salah satu pantai terbaik di dunia. Surga bagi peselancar. 🏄‍♂️", poster: "/posters/nihiwatu.jpg" },
    { name: "Danau Weekuri", location: "Sumba Barat Daya, NTT", note: "Laguna air asin yang sangat bening di celah karang laut. 🌊", poster: "/posters/weekuri.jpg" },
    { name: "Danau Kelimutu", location: "Ende, Flores, NTT", note: "Tiga danau kawah dengan warna yang berubah-ubah secara periodik. 🎨", poster: "/posters/kelimutu.jpeg" },
    { name: "Pantai Ora", location: "Maluku Tengah, Maluku", note: "Maladewa-nya Indonesia dengan resort di atas air jernih. 🏝️", poster: "/posters/ora.jpg" },
    { name: "Danau Sentani", location: "Jayapura, Papua", note: "Danau luas dengan Bukit Teletubbies yang hijau di sekelilingnya. ⛰️", poster: "/posters/sentani.jpg" },
    
    // --- Destinasi Internasional ---
    { name: "Dolomites", location: "Italia Utara", note: "Puncak batu kapur tajam dan danau pegunungan yang sangat estetik. 🇮🇹", poster: "/posters/dolomites.jpg" },
    { name: "Switzerland", location: "Eropa Tengah", note: "Pegunungan Alpen, desa Lauterbrunnen, dan kereta panorama. 🇨🇭", poster: "/posters/swiss.jpg" },
    { name: "Praha (Prague)", location: "Republik Ceko", note: "Kastil abad pertengahan dan Jembatan Charles yang romantis. 🇨🇿", poster: "/posters/praha.jpg" },
    { name: "Kyoto", location: "Jepang", note: "Ribuan kuil tradisional dan Hutan Bambu Arashiyama yang ikonik. 🇯🇵", poster: "/posters/kyoto.jpg" },
  ];

  return (
    <motion.div 
      className="category-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="category-header">
        <h2 className="main-title">Travel Bucket List ✈️</h2>
        <p className="subtitle" style={{ marginBottom: "50px" }}>
          Exploring the wonders of Indonesia and the world, one dream at a time.
        </p>
      </div>

      <div className="film-grid">
        {dreamPlaces.map((place, i) => (
          <motion.div 
            key={i} 
            className="film-card-visual"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.05 }}
            whileHover={{ y: -10 }}
          >
            <div className="poster-wrapper">
              <img 
                src={place.poster} 
                alt={place.name} 
                onError={(e) => {e.target.src = "https://via.placeholder.com/400x300?text=Dream+Destination"}}
              />
            </div>
            <div className="film-details">
              <h4>{place.name}</h4>
              <span className="film-meta">{place.location}</span>
              <p className="film-desc">{place.note}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Places;